import { PaymentStatus } from 'constants/payment';
import { useAppSelector } from 'store/hooks';
import { CheckError } from 'views/components/base/check-error';
import { LoadingState } from 'views/shared/loading-state';

import { PaymentContainer } from '../payment-container';

const BaseCardWrapper = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const renderBaseCard = () => {
    switch (paymentData?.status) {
      case PaymentStatus.WAIT_PAYMENT:
      case PaymentStatus.PAYMENT_SUCCESS:
      case PaymentStatus.WAIT_PROCESSING:
      case PaymentStatus.HOLDED:
      case PaymentStatus.PAYMENT_FAILED:
      case PaymentStatus.INTERNAL_ERROR:
        return <PaymentContainer />;
      case PaymentStatus.INVOICE_DISABLED:
      case PaymentStatus.RETRYABLE_FAILED:
      case PaymentStatus.PAYMENT_TIMEOUT:
      case PaymentStatus.INCORRECT_DATA:
      case PaymentStatus.PAYMENT_NOTFOUND:
      case PaymentStatus.ANTIFROD_DECLINED:
        return <CheckError />;
      default:
        return <LoadingState />;
    }
  };

  return renderBaseCard();
};

export { BaseCardWrapper };
